import { authFetch, authHeaders, resolveApiBaseUrl } from '../auth';
import { apiUrl } from './http';

export const emailMethods = {
// Log email sending status
  async logEmail(orderId, emailType, status, recipientEmail, subject, sentStatus, errorMessage = '', messageId = '') {
    try {
      const result = await this.makeAPICall('/emails/log/', 'POST', {
        order_id: orderId,
        email_type: emailType,
        status: status,
        recipient_email: recipientEmail,
        subject: subject,
        sent_status: sentStatus,
        error_message: errorMessage,
        message_id: messageId
      });

      return {
        success: true,
        message: result.message,
        log_id: result.log_id
      };
    } catch (error) {
      console.error('Failed to log email:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
};
